/**
     * @includeToDoc
     */
export interface IValidationLocalizer {
    getLocalization(code: string): string;
}

export enum ValidateErrors {
    valid = 0,
    badInput = 1,
    customError = 2,
    patternMismatch = 4,
    rangeOverflow = 8,
    rangeUnderflow = 16,
    stepMismatch = 32,
    tooLong = 64,
    typeMismatch = 128,
    valueMissing = 256,
}

export enum ValidatingDataType {
    float,
    integer,
    date,
    time,
    dateTime,
    string,
}
